import React from 'react';

import styled from 'styled-components';
import { Button } from 'styles/admin';
import { StyledBox, StyledTypography } from 'styles/common';

import NotAvailable from 'assets/images/NotAvailable.png';

const EmptyError = ({
  errorMessage = 'It looks empty here!',
  errorSubtitle = null,
  reloadHandler = null,
  imageWidth = '100%',
}) => (
  <StyledBox topGutter={2} bottomGutter={2} flexcontainer justifycontent="center" alignitems="center">
    <ErrorContainer>
      <img width={imageWidth} src={NotAvailable} />
      <StyledTypography variant="body2">{errorMessage}</StyledTypography>
      {errorSubtitle && (
        <StyledBox variant="caption" color="textSecondary" topGutter={0.5}>
          {errorSubtitle}
        </StyledBox>
      )}

      {typeof reloadHandler === 'function' && (
        <StyledBox topGutter={1}>
          <Button blue onClick={reloadHandler}>
            Reload
          </Button>
        </StyledBox>
      )}
    </ErrorContainer>
  </StyledBox>
);

export default EmptyError;

const ErrorContainer = styled.div`
  height: 100%;
  width: 100%;
  max-width: 40vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
